export function formatDate(dateString) {
    if (!dateString) return "";
    return dateString.slice(0, 10); // Extracts "YYYY-MM-DD"
  }